import { ToastOptions } from 'react-toastify'

import { SHOW_TOAST } from '../types/toast'

interface ShowToastOptions extends ToastOptions {
  viewAllHref?: string
}

export const showToast = (msg: string, type: string, options?: ShowToastOptions) => {
  return { type: SHOW_TOAST, payload: { msg: msg, type: type, ...options } }
}
